import Constants from '../utils/consts';
import Cookies from 'universal-cookie';

var http = require('follow-redirects').https;
var qs = require('querystring');
const db = new Cookies().get('db', { path: '/' });

export default async function addZoomMeeting(uname, token, titolo, data, durata, oggetto) {
    return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': Constants.apisFolder + 'createZoomMeeting.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            const resp = JSON.parse(body.toString());
            resolve(resp);
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
            'token': token,
            'uname': uname,
            'titolo': titolo, 
            'oggetto': oggetto, 
            'data': data, 
            'durata': durata,
            'db_name': db
        });

        req.write(postData);

        req.end();

        
    });
}
